module.exports = __webpack_public_path__ + "static/media/gateway.b923646e.svg";